import React from 'react';
import HeroSection from '../components/home/HeroSection';
import StatsBar from '../components/home/StatsBar';
import RegionSection from '../components/home/RegionSection';
import BrowseCategorySection from '../components/home/BrowseCategorySection';
import PartnerLifeSection from '../components/home/PartnerLifeSection';
import MovingNowSection from '../components/home/MovingNowSection';
import IntelligenceSection from '../components/home/IntelligenceSection';
import TrustedSection from '../components/home/TrustedSection';
import LocationsSection from '../components/home/LocationsSection';
import JoinCTASection from '../components/home/JoinCTASection';
import '../styles/HomePage.css';

const HomePage: React.FC = () => (
  <div className="home-page">
    <HeroSection />
    <StatsBar />
    <RegionSection />
    <BrowseCategorySection />
    <PartnerLifeSection />
    <MovingNowSection />
    <IntelligenceSection />
    <TrustedSection />
    <LocationsSection />
    <JoinCTASection />
  </div>
);

export default HomePage;
